import BaseService from '../base';
import { IRankDataRequest } from './types';


class RankService extends BaseService {
  getRankData(roomId: number) {
    const params: IRankDataRequest = {
      room_id: roomId,
      ts: Math.floor(Date.now() / 1000),
    };
    return this.get({
      url: '/web/live/treasure/rank',
      params,
    });
  }
}
const srvInstance = new RankService();

export default srvInstance;


